// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { laptop16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-laptop': IconLaptop;
    }
}

/**
 * The icon component for the 'laptop' icon
 */
export class IconLaptop extends Icon {
    public constructor() {
        super(laptop16X16);
    }
}

registerIcon('icon-laptop', IconLaptop);
export const iconLaptopTag = 'nimble-icon-laptop';
